/* eslint-disable */
import { StyleSheet, Platform } from 'react-native'
import { Colors, Metrics, ApplicationStyles } from '../../Themes/'
import  {isIPhoneX, ifIPhoneX} from '../../Lib/utils'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  statusBar: {
    ...Platform.select({
      ios: ifIPhoneX({ height: 31 }, { height: 20 }), // 44
      android: { height: 0  },
      web: { height: 0 }
    }),
    backgroundColor: '#000000',
  },
  container: {
    flex: 1
   },
   header: {
     marginBottom: 5
   },
   input: {
     borderColor: 'gray',
     borderWidth: 1,
     marginBottom: 5,
     padding: 5,
     width: 200
   },
   footerButton: {
     height: isIPhoneX() ? 76 : 64,
     paddingBottom: 14,
   },
})
